<div class="container-fluid">
    <div>
        <div class="d-flex m-3">
            <div class="mr-2">
                <button mat-icon-button (click)="back()">
                    <mat-icon style="color: #00FF00;" svgIcon="feather:arrow-left-circle"></mat-icon>
                </button>
            </div>
            <h2 class="h3 createHeading">{{title}}</h2>
        </div>

        <div class="card dataCard m-1" *ngIf="userOrderPlanInfo">
            <div class="m-2">
                <div class="row ml-2">
                    <div class=" col-sm-6 col-md-6 col-lg-3">
                        <span class="listFont">Customer:</span>
                        <span style="font-size: 20px; font-weight: 400;" class=""> {{userOrderPlanInfo.user.full_name}}</span>
                    </div>
                    <div class=" col-sm-6 col-md-6 col-lg-3">
                        <span class="listFont">Branch:</span>
                        <span style="font-size: 20px; font-weight: 400;" class=""> {{userOrderPlanInfo.branch.name}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card dataCard m-1" *ngIf="slotBookingInfo">
            <div class="m-2">
                <div class="row ml-2">
                    <div class=" col-sm-6 col-md-6 col-lg-4">
                        <span class="listFont">Customer:</span>
                        <span style="font-size: 20px; font-weight: 400;" class="">{{slotBookingInfo.user.full_name}}</span>
                    </div>
                    <div class=" col-sm-6 col-md-6 col-lg-4">
                        <span class="listFont">Trainer:</span>
                        <span style="font-size: 20px; font-weight: 400;" class=""> {{slotBookingInfo.trainer.full_name}}</span>
                    </div>
                    <div class=" col-sm-6 col-md-6 col-lg-4">
                        <span class="listFont">Branch:</span>
                        <span style="font-size: 20px; font-weight: 400;" class=""> {{slotBookingInfo.branch.name}}</span>
                    </div>
                    <div class=" col-sm-6 col-md-6 col-lg-4">
                        <span class="listFont">Slot Date</span>
                        <span style="font-size: 20px; font-weight: 400;" class=""> {{slotBookingInfo.slotDate | dateFormat}}</span>
                    </div>
                    <div class=" col-sm-6 col-md-6 col-lg-4">
                        <span class="listFont">Slot Time</span>
                        <span style="font-size: 20px; font-weight: 400;" class=""> {{slotBookingInfo.slotTime}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="card"  style="background-color: #FFFFFF;height: auto;padding: 10px; ">
            <div class="mt-2 ml-3 mb-4">
                <div class="row  mr-3 ml-3 mt-3">

                    <div class="col-md-4">
                        <div class="fw-bold fieldName">
                            Slot Date
                            <span class="text-danger">*</span>
                        </div>
                        <div class="">
                            <mat-form-field class="flex-auto gt-xs:pr-3 w-full">
                                <input matInput readonly [matDatepicker]="picker" 
                                [(ngModel)]="selectedSlotDate" (ngModelChange)="getAvailableTimeSlots()"
                                [placeholder]="'Slot Date'" >
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="fw-bold fieldName">
                            Slot Time
                            <span class="text-danger">*</span>
                        </div>
                        <div class="">
                            <mat-form-field class="flex-auto gt-xs:pr-3 w-full" name="slotTime" style="width: 90%;">
                                <mat-select [placeholder]="'Select Time'" [(ngModel)]="selectedSlotTimeAlias" (ngModelChange)="getAvailableTrainers()">
                                    <mat-option *ngFor="let timeSlot of availableSlotTimes" [value]="timeSlot.alias">{{timeSlot.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="fw-bold fieldName">
                            Trainer
                            <span class="text-danger">*</span>
                        </div>
                        <div class="">
                            <mat-form-field class="flex-auto gt-xs:pr-3 w-full" name="trainerId" style="width: 90%;">
                                <mat-select [placeholder]="'Select Trainer'" [(ngModel)]="selectedTrainerId">
                                    <mat-option *ngFor="let trainer of availableTrainers" [value]="trainer.id">{{trainer.full_name}}&nbsp;({{trainer.role.name}})</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="btnposition">
        <div class="bottomBtns mb-3 row">
            <button class="ml-4 addBtn"  mat-flat-button (click)="reset()">
                <span class="ml-2 mr-1 txt">Reset</span>
            </button>
           
            <button class="ml-4 mr-6 addBtn" [ngClass]="{'btn-clr': selectedTrainerId}" mat-flat-button [color]="'primary'" (click)="createSchedule()" *ngIf="!isUpdateSchedule" [disabled]="!selectedTrainerId">
                <span class="ml-2 mr-1 txt" style="color: white">Create </span>
            </button>

            <button class="ml-4 mr-6 addBtn" [ngClass]="{'btn-clr': selectedTrainerId}" mat-flat-button [color]="'primary'" (click)="updateSchedule()" *ngIf="isUpdateSchedule" [disabled]="!selectedTrainerId">
                <span class="ml-2 mr-1 txt" style="color: white">Update</span>
            </button>
        </div>
    </div>
</div>